/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idnes_PasswordInputs */

const cs_idnes_password = /** @type {(inputs: Idnes_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importní heslo`)
};

const en_idnes_password = /** @type {(inputs: Idnes_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import password`)
};

/**
* | output |
* | --- |
* | "Import password" |
*
* @param {Idnes_PasswordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const idnes_password = /** @type {((inputs?: Idnes_PasswordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idnes_PasswordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_idnes_password(inputs)
	return cs_idnes_password(inputs)
});